import EmployeeGroupScheduleFormStore from "@/modules/company/stores/group/schedule/emp_group_schedule_form.store";
import EmployeeeGroupScheduleListStore from "@/modules/company/stores/group/schedule/emp_group_schedule_list.store";

export default {
  modules: {
    EmployeeGroupScheduleFormStore,
    EmployeeeGroupScheduleListStore,
  },
};
